import Chartjs from '@stimulus-components/chartjs';
import type { Chart, ActiveElement, ChartEvent } from "chart.js";

export default class extends Chartjs {

  static targets = [ "input" ];
  static values = {
    selectedIndex: Number,
    selectedDatasetIndex: { type: Number, default: 0 }
  };

  connect(): void {
    super.connect();

    // Chart.js click handler
    this.chart.options.onClick = (
      event: ChartEvent,
      elements: ActiveElement[]
    ) => {
      if (elements.length === 0) return

      const { datasetIndex, index } = elements[0];
      
      // Set value properties
      this.selectedIndexValue = index;
      this.selectedDatasetIndex = datasetIndex;

      
      const dataset = this.chart.data.datasets[datasetIndex];
      const value = dataset.data[index];
      const label = this.chart.data.labels?.[index];

      console.log("[ChartJS Click] Label: ", label, ", Value: ", value);

      this.chart.update();

      // Set the dataset value on the hidden element
      this.#hiddenInputElement.value = label;
      this.#hiddenInputElement.dispatchEvent(new CustomEvent('change', { bubbles: true }));

      this.dispatch("point-clicked", {
        detail: {
          datasetIndex,
          index,
          label,
          value
        }
      });



    }
  }

  get chartData() {
    const data = super.chartData

    data.datasets = data.datasets.map((dataset, datasetIndex) => ({
      ...dataset,

      pointRadius: ctx =>
        this.isSelected(ctx, datasetIndex) ? 7 : 4,

      borderWidth: ctx =>
        this.isSelected(ctx, datasetIndex) ? 3 : 1,

      backgroundColor: ctx =>
        this.isSelected(ctx, datasetIndex)
          ? "#3786d3"
          : dataset.backgroundColor
    }))

    return data
  }


  isLine(dataset) {
    return dataset.type === "line" || this.chart.config.type === "line"
  }

  isBar(dataset) {
    return dataset.type === "bar" || this.chart.config.type === "bar"
  }


  isSelected(ctx, datasetIndex) {
    return(
      ctx.dataIndex === this.selectedIndexValue
      // &&  datasetIndex  === this.selectedDatasetIndexValue
    )
  }


  get #hiddenInputElement() {
    return this.inputTarget;
  }

  get #selectedLabel() {
    this.chart.data.labels?.[this.selectedIndexValue];
  }

}
